import { render } from "./LiverSpecificSectionEMROATS.vue?vue&type=template&id=5096226e&scoped=true"
import script from "./LiverSpecificSectionEMROATS.vue?vue&type=script&lang=js"
export * from "./LiverSpecificSectionEMROATS.vue?vue&type=script&lang=js"

import "./LiverSpecificSectionEMROATS.vue?vue&type=style&index=0&id=5096226e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5096226e"],['__file',"src/components/LiverSpecificSectionEMROATS.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5096226e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5096226e', __exports__)) {
    api.reload('5096226e', __exports__)
  }
  
  module.hot.accept("./LiverSpecificSectionEMROATS.vue?vue&type=template&id=5096226e&scoped=true", () => {
    api.rerender('5096226e', render)
  })

}


export default __exports__